// Разделитель иконок (не требуется)
import React from 'react';
export var IndicatorSeparator = function () {
    return React.createElement("div", null);
};
//# sourceMappingURL=IndicatorSeparator.js.map// Разделитель иконок (не требуется)
import React from 'react';
export var IndicatorSeparator = function () {
    return React.createElement("div", null);
};
//# sourceMappingURL=IndicatorSeparator.js.map